const macOsNavigatorRegex = /(Mac|iPad)/i;
export const isMacOs = (): boolean => macOsNavigatorRegex.test(navigator.platform);

export const isOS = {
  WIN: navigator.userAgent.indexOf('Win') > -1,
  MAC: navigator.userAgent.indexOf('Mac') > -1,
};
